// Official brand marks as inline SVGs (no icon-set dependency).

export const SlackMark = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path fill="#E01E5A" d="M5.04 15.41A2.52 2.52 0 1 1 2.52 12.9h2.52v2.51z" />
    <path fill="#E01E5A" d="M6.31 15.41a2.52 2.52 0 1 1 5.04 0v6.27a2.52 2.52 0 1 1-5.04 0v-6.27z" />
    <path fill="#36C5F0" d="M8.83 5.04a2.52 2.52 0 1 1 2.52-2.52v2.52H8.83z" />
    <path fill="#36C5F0" d="M8.83 6.31a2.52 2.52 0 1 1 0 5.04H2.56a2.52 2.52 0 1 1 0-5.04h6.27z" />
    <path fill="#2EB67D" d="M18.96 8.83a2.52 2.52 0 1 1 2.52 2.52h-2.52V8.83z" />
    <path fill="#2EB67D" d="M17.69 8.83a2.52 2.52 0 1 1-5.04 0V2.56a2.52 2.52 0 1 1 5.04 0v6.27z" />
    <path fill="#ECB22E" d="M15.17 18.96a2.52 2.52 0 1 1-2.52 2.52v-2.52h2.52z" />
    <path fill="#ECB22E" d="M15.17 17.69a2.52 2.52 0 1 1 0-5.04h6.27a2.52 2.52 0 1 1 0 5.04h-6.27z" />
  </svg>
);

export const AircallMark = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <rect x="1" y="1" width="22" height="22" rx="6" fill="#00BD82" />
    <path
      fill="#fff"
      d="M7.6 6.4c.7-.7 1.9-.6 2.5.2l1 1.4c.5.7.4 1.6-.2 2.2l-.6.6c.3.8.8 1.5 1.4 2.1.6.6 1.3 1.1 2.1 1.4l.6-.6c.6-.6 1.5-.7 2.2-.2l1.4 1c.8.6.9 1.8.2 2.5l-.8.8c-.7.7-1.7 1-2.7.7-2-.6-3.9-1.7-5.4-3.2S6.7 12 6.1 10c-.3-1-.1-2 .7-2.7l.8-.9z"
    />
  </svg>
);
